var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mb-5"},[_c('div',{staticClass:"card-body py-5"},[_c('p',{staticClass:"text-center text-muted mb-0"},[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }